var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarHome1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 10.6654V26.6654C4 27.019 4.14048 27.3581 4.39052 27.6082C4.64057 27.8582 4.97971 27.9987 5.33333 27.9987H12C12.3536 27.9987 12.6928 27.8582 12.9428 27.6082C13.1929 27.3581 13.3333 27.019 13.3333 26.6654V17.332H18.6667V26.6654C18.6667 27.019 18.8071 27.3581 19.0572 27.6082C19.3072 27.8582 19.6464 27.9987 20 27.9987H26.6667C27.0203 27.9987 27.3594 27.8582 27.6095 27.6082C27.8595 27.3581 28 27.019 28 26.6654V10.6654C28 10.4584 27.9518 10.2542 27.8592 10.0691C27.7667 9.88394 27.6323 9.7229 27.4667 9.5987L16.8 1.5987C16.5692 1.4256 16.2885 1.33203 16 1.33203C15.7115 1.33203 15.4308 1.4256 15.2 1.5987L4.53333 9.5987C4.36774 9.7229 4.23333 9.88394 4.14076 10.0691C4.04819 10.2542 4 10.4584 4 10.6654ZM6.66667 11.332L16 4.33203L25.3333 11.332V25.332H21.3333V15.9987C21.3333 15.6451 21.1929 15.3059 20.9428 15.0559C20.6928 14.8058 20.3536 14.6654 20 14.6654H12C11.6464 14.6654 11.3072 14.8058 11.0572 15.0559C10.8071 15.3059 10.6667 15.6451 10.6667 15.9987V25.332H6.66667V11.332Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarHome1);
export default __webpack_public_path__ + "static/media/sidebar_home1.10713ca059a7f073e81a3edfbf870223.svg";
export { ForwardRef as ReactComponent };